import {
  Environment
} from '@vodacom/web-env';

import {
  JavascriptTypes
} from '../../../constants';

import {
  AppState
} from 'helpers';

export class WeatherProvider {

  static STATE = AppState.with('WeatherProvider');

  static getWeather(city, lat, lon) {

    return WeatherProvider.STATE.makeServiceCall(
      `${Environment.current.apiHost}/weather`, {
        method: 'GET',
        headers: {},
        queryParams: {
          city: city,
          lat: lat,
          lon: lon
        },
        cacheKey: `weather--${ city || `${lat},${lon}` }`
      }
    )
      .then(res => {

        if (!res?.result) {
          return {
            ok: false,
            error: new Error('Weather data not found'),
            trace: null,
            date: null,
            result: null,
            code: null,
            stamp: new Date()
          };
        }

        return res;
    })
      .catch(error => {

        return {
          ok: false,
          error: error,
          trace: null,
          date: null,
          result: null,
          code: null,
          stamp: new Date()
        };
      });
  }

  static getWeatherForecast(city, lat, lon) {

    return WeatherProvider.STATE.makeServiceCall(
      `${Environment.current.apiHost}/weather/forecast`, {
        method: 'GET',
        headers: {},
        queryParams: {
          city: city,
          lat: lat,
          lon: lon
        },
        cacheKey: `weatherForecast--${city || `${lat},${lon}`}`
      }
    )
      .then(res => {

        if (!res?.result) {
          return {
            ok: false,
            error: new Error('Weather data not found'),
            trace: null,
            date: null,
            result: null,
            code: null,
            stamp: new Date()
          };
        }

        return res;
    })
      .catch(error => {

        return {
          ok: false,
          error: error,
          trace: null,
          date: null,
          result: null,
          code: null,
          stamp: new Date()
        };
      });
  }

  static async getCachedItem(key, fallback, serviceFallback) {

    const cachedItem = WeatherProvider.STATE.getItem(key, fallback);

    if (!cachedItem && serviceFallback && typeof serviceFallback === JavascriptTypes.Function) {
      const response = await serviceFallback();

      if (response.ok && response.result) {
        return response;
      }
    }

    return cachedItem;
  }
}
